import { create } from 'zustand';
import { CharacterSimple } from '@client/components';

interface StoreState {
  currentPage: number;
  loading: boolean;
  isOwner: boolean;
  maxPage: number;
  characters: CharacterSimple[];
  sortType: 'hot' | 'latest' | 'random' | 'tags';
  tag?: string;
  gender?: 'male' | 'female';
  setCurrentPage: (page: number) => void;
  setLoading: (loading: boolean) => void;
  setCharacters: (characters: CharacterSimple[]) => void;
  setIsOwner: (isOwner: boolean) => void;
  setMaxPage: (maxPage: number) => void;
  setSortType: (type: 'hot' | 'latest' | 'random' | 'tags') => void;
  setTag: (tag?: string) => void;
  setGender: (gender?: 'male' | 'female') => void;
}

export const useHomeStore = create<StoreState>((set, get) => ({
  currentPage: 1,
  loading: false,
  isOwner: false,
  maxPage: 0,
  characters: [],
  sortType: 'hot',
  tag: undefined,
  gender: undefined,
  setCurrentPage: (currentPage) => set({ currentPage }),
  setLoading: (loading) => set({ loading }),
  setCharacters: (characters) => set({ characters }),
  setIsOwner: (isOwner) => set({ isOwner }),
  setMaxPage: (maxPage) => set({ maxPage }),
  setSortType: (sortType) =>
    set((state) => ({
      sortType,
      currentPage: state.currentPage,
      tag: sortType === 'tags' ? state.tag : undefined,
      gender: sortType === 'tags' ? state.gender : undefined,
    })),
  setTag: (tag) =>
    set((state) => ({
      tag,
      sortType: 'tags',
      currentPage: state.currentPage,
    })),
  setGender: (gender) =>
    set((state) => ({
      gender,
      currentPage: state.currentPage,
    })),
}));
